import * as localStorage from 'Helpers/Localstorage.helper'
import { getSearchURL } from 'Helpers/Url.helper'

export const getLocale = () => {
  const storageLang = localStorage.getItem('odash-app:lang')
  const browserLang = navigator && navigator.language
  return getSearchURL('lang') || getSearchURL('locale') || (storageLang !== null ? storageLang : null) || browserLang || 'pt-BR'
}
